module.exports = __webpack_public_path__ + "img/四川天府新区（光亚学校）.abbaf40a.jpg";